import { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import NaviFormComponent from './naviFormComponent';
import NaviResultComponent from './naviResultComponent';
import naviSearchModel from './naviSearchModel';
import NaviURL from './naviURL';

let naviRestoreData = null;
const NaviComponent = forwardRef(({
  map,isShowNavi,setIsShowNavi,naviToggle,naviSearch,setNaviSearch,isSearchResultOpen,isTablet,style
}, ref) => {
  let isRouteRendered = (naviSearch.driveResult || naviSearch.walkResult || naviSearch.transitResult) && naviSearch.resultRendered;

  const [naviStart, setNaviStart] = useState(naviSearchModel.start);
  const [naviEnd, setNaviEnd] = useState(naviSearchModel.end);
  const [resultError, setResultError] = useState(naviSearchModel.resultError);
  
  const [naviVia1, setNaviVia1] = useState(null);
  const [naviVia2, setNaviVia2] = useState(null);
  const [naviVia3, setNaviVia3] = useState(null);
  const [naviVia4, setNaviVia4] = useState(null);
  const [naviVia5, setNaviVia5] = useState(null);

  const [isSmp, setIsSmp] = useState(false);

  const naviFormRef = useRef();
  const naviURLRef = useRef();

  // naviRestoreDataがあって、ナビが表示されたらデータを復旧する
  if(isShowNavi && naviRestoreData){
    let {start, end, via1, via2, via3, via4, via5} = naviRestoreData;
    setNaviStart(start);
    setNaviEnd(end);
    setNaviVia1(via1);
    setNaviVia2(via2);
    setNaviVia3(via3);
    setNaviVia4(via4);
    setNaviVia5(via5);

    naviRestoreData = null; // 保持したデータを空にする
  } else if(!isShowNavi && !naviRestoreData){
   // naviRestoreDataがなく、ナビが非表示にされたらデータを保持する
    naviRestoreData = {
      start: naviStart,
      end: naviEnd,
      via1: naviVia1,
      via2: naviVia2,
      via3: naviVia3,
      via4: naviVia4,
      via5: naviVia5,
    }
    // 初期値を設定して、非検索状態にしておく
    setNaviStart(naviSearchModel.start);
    setNaviEnd(naviSearchModel.end);
    setNaviVia1(null);
    setNaviVia2(null);
    setNaviVia3(null);
    setNaviVia4(null);
    setNaviVia5(null);
  }

  const naviFromToggle = (bool, isCompulsionToggle, isSpPointTap)=>{
    if(isShowNavi && isRouteRendered && isSmp && isSpPointTap){
      // SPの結果表示状態でルートのポイントタップの場合は何もしない
      return ;
    }else if(isShowNavi && isRouteRendered && !isSmp && isSpPointTap){
      // ナビフォームが表示状態でSPの結果表示状態でルートのポイントタップの場合は
      // ナビフォームを閉じてSP用の検索結果を表示する
      setIsSmp(true);
    }else if(!isRouteRendered || isCompulsionToggle){
       // 結果も何もない、もしくは、強制的にトグルさせる場合はナビ表示フォームのトグルをする
      if(typeof bool=== "boolean"){
        setIsShowNavi(bool);
      } else {
        setIsShowNavi(!isShowNavi);
      }
    }else if(isShowNavi && isRouteRendered && !isTablet){
      // SP表示じゃなくて結果アリでisShowNaviが閉じる
      setIsShowNavi(false);
    }else if(isShowNavi && isRouteRendered && isSmp){
      // 検索結果あり、SP用表示状態の時はSP表示状態を解除してナビフォームを表示
      setIsSmp(false);
    }else if(isShowNavi && isRouteRendered && !isSmp){
      // 検索結果があり、かつ、ナビフォーム表示→閉じるの場合はSP用表示をする
      setIsSmp(true);
    }
  }

  // ワード検索モーダルが開いているときはナビを非表示にする
  if(isSearchResultOpen){
    naviFromToggle(false, true);
  }

  // 外部コンポーネントからのナビルート設定
  const setNaviRoute = ({name, lat, lon}) =>{
    naviFromToggle(true, true); // 強制的にナビを表示する
    // POIなどで検索の場合は目的地を設定する
    if(name && lat && lon){
      let {current: {setNaviRoute}} = naviFormRef;
      // POIなどから開かれたときに上のnaviRestoreDataの復旧が走ってしまうので、
      // setTimeout使って、データ復旧してからPOIのデータをセットする。
      // ※本当は復旧箇所で何かしらしたほうがいいかもしれないが...一旦いいかな...?
      setTimeout(()=>{
        setNaviRoute({name, lat, lon});
      }, 100);
    }
  }

  // ナビのURLパラメータをセットする
  const setNaviURLParam = ()=>{
    let {current: {setNaviURLParam}} = naviURLRef;
    setNaviURLParam();
  }

  useImperativeHandle(ref, () => ({
    naviFromToggle: naviFromToggle,
    setNaviRoute:setNaviRoute
  }));

  return (
    <div
      className={`route-search-mode ${isShowNavi ? 'active' : ''} ${isRouteRendered? 'route-rendered': ''} ${isSmp? 'route-smp-result': ''}`}
      style={isShowNavi? {}: {"display": "none"}}
    >
      { isRouteRendered && isSmp && isTablet && (
        <div className="navi-sp-close-wrap">
          <div className={"navi-sp-close-btn"}></div>
          <button className={"navi-sp-open-up-btn"} onClick={(e) => {  e.stopPropagation(); naviToggle(true); }}>
            <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/keyboard_arrow_up_24.svg')` }}></i>
          </button>
          <div className={"navi-sp-close-btn"}>
            <button className={"map-control-btn"} onClick={(e) => {  e.stopPropagation(); setIsShowNavi(false); }}>
              <i className="svg-icon-blue" style={{ backgroundImage: `url('assets/icons/close_24.svg')` }}></i>
            </button>
          </div>
        </div>
      )}
      <NaviFormComponent
        naviToggle={naviToggle}
        naviSearch={naviSearch}
        setNaviSearch={setNaviSearch}
        naviStart={naviStart}
        setNaviStart={setNaviStart}
        naviEnd={naviEnd}
        setNaviEnd={setNaviEnd}
        map={map}
        setResultError={setResultError}
        naviVia1={naviVia1} setNaviVia1={setNaviVia1}
        naviVia2={naviVia2} setNaviVia2={setNaviVia2}
        naviVia3={naviVia3} setNaviVia3={setNaviVia3}
        naviVia4={naviVia4} setNaviVia4={setNaviVia4}
        naviVia5={naviVia5} setNaviVia5={setNaviVia5}
        naviFromToggle={naviFromToggle}
        isShowNavi={isShowNavi}
        ref={naviFormRef}
        isTablet={isTablet}
      />
      <NaviResultComponent
        map={map}
        naviSearch={naviSearch}
        setNaviSearch={setNaviSearch}
        naviToggle={naviToggle}
        naviStart={naviStart}
        setNaviStart={setNaviStart}
        naviEnd={naviEnd}
        setNaviEnd={setNaviEnd}
        resultError={resultError}
        setResultError={setResultError}
        naviVia1={naviVia1}
        naviVia2={naviVia2}
        naviVia3={naviVia3}
        naviVia4={naviVia4}
        naviVia5={naviVia5}
        isSmp={isSmp}
        setIsSmp={setIsSmp}
        naviFromToggle={naviFromToggle}
        setNaviURLParam={setNaviURLParam}
        isTablet={isTablet}
        style={style}
      />

      <NaviURL
        naviToggle={naviToggle}
        setNaviSearch={setNaviSearch}
        naviSearch={naviSearch}

        naviStart={naviStart}
        setNaviStart={setNaviStart}
        naviEnd={naviEnd}
        setNaviEnd={setNaviEnd}
        naviVia1={naviVia1} setNaviVia1={setNaviVia1}
        naviVia2={naviVia2} setNaviVia2={setNaviVia2}
        naviVia3={naviVia3} setNaviVia3={setNaviVia3}
        naviVia4={naviVia4} setNaviVia4={setNaviVia4}
        naviVia5={naviVia5} setNaviVia5={setNaviVia5}
        isShowNavi={isShowNavi}
        ref={naviURLRef}
        map={map}
        isRouteRendered={isRouteRendered}

      />

    </div>
  );
});

export default NaviComponent;